const heroTranslations = {
    EN: {
        title: "Sri Kurumba Bhagavathy Temple",
        subtitle: "A Place of Divine Peace & Devotion",
        description:
            "Experience the serenity of ancient traditions and connect with the divine",
        contact: "Contact Us",
        donation: "Make a Donation",
    },

    TA: {
        title: "ஸ்ரீ குரும்பா பகவதி ஆலயம்",
        subtitle: "தெய்வீக அமைதி மற்றும் பக்தியின் இடம்",
        description:
            "பண்டைய பாரம்பரியத்தின் அமைதியை அனுபவித்து தெய்வத்துடன் இணைக",
        contact: "எங்களை தொடர்பு கொள்ளுங்கள்",
        donation: "தானம் செய்யுங்கள்",
    },

    ML: {
        title: "ശ്രീ കുറുമ്പ ഭഗവതി ക്ഷേത്രം", 
        subtitle: "ദൈവിക സമാധാനത്തിന്റെയും ഭക്തിയുടെയും കേന്ദ്രം",
        description:
            "പാരമ്പര്യങ്ങളുടെ ശാന്തത അനുഭവിച്ച് ദൈവവുമായി ബന്ധപ്പെടുക",
        contact: "ഞങ്ങളെ ബന്ധപ്പെടുക",
        donation: "സംഭാവന നൽകുക",
    },
};

export default heroTranslations;